import { mallTradeApi } from '../request'
import { apiPath } from '../api'

export const cart = {
  list: () => mallTradeApi.post(apiPath.cartList),
  put: data => mallTradeApi.post(apiPath.cartPut, data),
  getActivityInfoById: data =>
    mallTradeApi.post(apiPath.getActivityInfoById, data)
}
